/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Booking_PackInputs */

const en_features_booking_pack = /** @type {(inputs: Features_Booking_PackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10-session pack`)
};

const pl_features_booking_pack = /** @type {(inputs: Features_Booking_PackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pakiet 10 treningów`)
};

/**
* | output |
* | --- |
* | "10-session pack" |
*
* @param {Features_Booking_PackInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_booking_pack = /** @type {((inputs?: Features_Booking_PackInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Booking_PackInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_booking_pack(inputs)
	return en_features_booking_pack(inputs)
});